function isEmpty(value) {
  return value === "" || value === null || value === undefined;
}

function validatePositiveInteger(value, fieldName) {
  if (isEmpty(value) || Number.isNaN(Number(value))) {
    return `${fieldName} es obligatorio.`;
  }

  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return `${fieldName} debe ser un entero positivo.`;
  }

  return null;
}

function validateDecimal(value, fieldName) {
  if (isEmpty(value)) {
    return `${fieldName} es obligatoria.`;
  }

  if (Number.isNaN(Number(value))) {
    return `${fieldName} debe ser un numero decimal valido.`;
  }

  if (Number(value) < 0) {
    return `${fieldName} no puede ser negativa.`;
  }

  return null;
}

export function validateTarifaEnterprisePayload({
  enterpriseId,
  priceBase,
  priceDistance,
  priceDuration,
  priceDelay,
}) {
  return (
    validatePositiveInteger(enterpriseId, "El id de la empresa") ||
    validateDecimal(priceBase, "El precio base") ||
    validateDecimal(priceDistance, "El precio distancia") ||
    validateDecimal(priceDuration, "El precio duracion") ||
    validateDecimal(priceDelay, "El precio espera")
  );
}
